import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean> = this.loadingSubject.asObservable();

  show() {
    this.loadingSubject.next(true);
    
    // Safety mechanism: Auto-hide loader after 30 seconds to prevent stuck loader
    timer(30000).pipe(take(1)).subscribe(() => {
      if (this.loadingSubject.value) {
        console.warn('Loader was active for more than 30 seconds, auto-hiding to prevent stuck loader');
        this.hide();
      }
    });
  }

  hide() {
    this.loadingSubject.next(false);
  }

  // Force hide loader (useful for cleanup)
  forceHide() {
    this.loadingSubject.next(false);
  }
} 